(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-information-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fresh-product-tabs')) {
    class FreshProductTabs extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected && !this.controller) this.initialize();
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }

      initialize() {
        this.panels = Array.from(this.querySelectorAll(':scope > [data-product-tab]'));
        this.contents = this.panels.map((panel) => panel.querySelector(':scope > .fresh-product-tabs__content'));
        this.navigation = this.querySelector(':scope > [data-tabs-nav]');
        if (!this.panels.length || !this.navigation) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.media = window.matchMedia('(min-width: 768px)');
        this.activeIndex = Math.max(0, this.panels.findIndex((panel) => panel.open));
        this.navigation.replaceChildren();
        this.navigation.setAttribute('role', 'tablist');
        this.buttons = this.panels.map((panel, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.id = `${panel.id}-tab`;
          button.className = 'fresh-product-tabs__tab';
          button.textContent = panel.querySelector('[data-tab-label]').textContent.trim();
          button.setAttribute('role', 'tab');
          button.setAttribute('aria-controls', this.contents[index].id);
          button.addEventListener('click', () => this.select(index), options);
          button.addEventListener('keydown', (event) => {
            let next = index;
            const rtl = getComputedStyle(this).direction === 'rtl';
            if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
            else if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.panels.length - 1;
            else return;
            event.preventDefault();
            next = (next + this.panels.length) % this.panels.length;
            this.select(next, true);
          }, options);
          panel.addEventListener('toggle', () => {
            if (panel.open && this.activeIndex !== index) {
              this.activeIndex = index;
              if (this.media.matches) this.select(index);
            }
          }, options);
          this.navigation.append(button);
          return button;
        });
        this.media.addEventListener('change', () => this.setLayout(), options);
        document.addEventListener('shopify:block:select', (event) => {
          if (this.contains(event.target) || event.target.contains(this)) {
            if (this.media.matches) this.select(this.activeIndex);
            else this.panels[this.activeIndex].open = true;
          }
        }, options);
        this.setLayout();
      }

      setLayout() {
        const desktop = this.media.matches;
        const previousFocus = document.activeElement;
        this.dataset.layout = desktop ? 'tabs' : 'accordion';
        this.navigation.hidden = !desktop;
        this.panels.forEach((panel, index) => {
          const content = this.contents[index];
          if (desktop) {
            content.setAttribute('role', 'tabpanel');
            content.setAttribute('aria-labelledby', this.buttons[index].id);
            content.tabIndex = 0;
          } else {
            content.removeAttribute('role');
            content.removeAttribute('aria-labelledby');
            content.removeAttribute('tabindex');
          }
        });
        if (desktop) {
          this.select(this.activeIndex);
          if (previousFocus?.matches('summary') && this.contains(previousFocus)) {
            this.buttons[this.activeIndex].focus();
          }
        } else if (this.buttons.includes(previousFocus)) {
          this.panels[this.activeIndex].querySelector('summary').focus();
        }
      }

      select(index, focus = false) {
        this.activeIndex = index;
        this.panels.forEach((panel, panelIndex) => {
          const selected = panelIndex === index;
          panel.open = selected;
          this.buttons[panelIndex].setAttribute('aria-selected', String(selected));
          this.buttons[panelIndex].tabIndex = selected ? 0 : -1;
        });
        if (focus) this.buttons[index].focus();
      }
    }
    customElements.define('fresh-product-tabs', FreshProductTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
